import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import ConvertPage from './pages/ConvertPage';
import MergePdf from './pages/MergePdf';
import SplitPdf from './pages/SplitPdf';
// Compress PDF is hidden until it actually shrinks files (it currently
// always reports 0% saved). /compress-pdf falls through to the 404 page.
// import CompressPdf from './pages/CompressPdf';
import RotatePdf from './pages/RotatePdf';
import RemoveBackground from './pages/RemoveBackground';
import ImageToText from './pages/ImageToText';
import ImageConvert from './pages/ImageConvert';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import AdminPanel from './pages/AdminPanel';
import Contact from './pages/Contact';
import About from './pages/About';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Articles from './pages/Articles';
import ArticleDetail from './pages/ArticleDetail';
import QRCodeGenerator from './pages/QRCodeGenerator';
import NotFound from './pages/NotFound';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="app">
          <ScrollToTop />
          <Toaster position="top-center" toastOptions={{ duration: 3000 }} />
          <Header />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/convert/:type" element={<ConvertPage />} />
              <Route path="/merge-pdf" element={<MergePdf />} />
              <Route path="/split-pdf" element={<SplitPdf />} />
              {/* <Route path="/compress-pdf" element={<CompressPdf />} /> */}
              <Route path="/rotate-pdf" element={<RotatePdf />} />
              <Route path="/remove-background" element={<RemoveBackground />} />
              <Route path="/image-to-text" element={<ImageToText />} />
              <Route path="/image-convert" element={<ImageConvert />} />
              
              <Route path="/qr-code-generator" element={<QRCodeGenerator />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/blogs" element={<Blog />} />
              <Route path="/blogs/:slug" element={<BlogPost />} />
              <Route path="/admin" element={<AdminPanel />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/about" element={<About />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/articles" element={<Articles />} />
              <Route path="/articles/:slug" element={<ArticleDetail />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;